import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { PlaceFieldBase } from './PlaceField'

import { placesSelector, bookedPlacesSelector } from 'reduxModules/selectors/RouteSelectors'

const mapStateToProps = createStructuredSelector({
  places: placesSelector,
  bookedPlaces: bookedPlacesSelector,
})

export const PlaceField =  connect(mapStateToProps)(PlaceFieldBase)



// WEBPACK FOOTER //
// ./src/components/PlaceField/index.js